<div [id]="`image-${this.data.id}`" [class.py-[8px]]="notInSlider" [class.px-[16px]]="notInSlider">
  <a
    #notionImageViewerLinkElementRef
    class="notion-image__viewer-link relative"
    [href]="`${config.baseUrl}`"
    [attr.data-pswp-src]="`${data.image.file.url}`"
    target="_blank"
  >
    <img
      #notionImageElementRef
      class="rounded-[8px]"
      [class.notion-image__in-slider--shadow]="!notInSlider"
      [src]="`${data.image.file.url}`"
      width="1920"
      height="1080"
      [alt]="data.image.file.url"
      loading="lazy"
    />
  </a>
  @if (data.image.caption.length) {
  <div class="notion-image__caption mt-[8px]">
    @for(c of data.image.caption; track $index) {
    <app-notion-text-component [data]="c"></app-notion-text-component>
    }
  </div>
  }
</div>
